// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__es5Hz","errorLogs":"EditorFooter_errorLogs__f69TM"};